import React from 'react';

import Header from './Header';

import Topbar from './TopBar';

import Footer from './Footer';

import ProductContainerpage from './ProductContainerpage';

const ProductContainer = () => {  
    
    return(
        <div>
            <Header/>
            <Topbar/>
            <ProductContainerpage/>
            <Footer/>
           
        </div>
        
    );
};

export default ProductContainer;